import { SELECT_NONE_OPTION } from '../../../../../utils/noneOptionUtil';
export { GENDER_OPTIONS } from 'e2e-common';

export enum typeOfCare {
  residentMonitoring = 1,
  restorativeNursing,
  skilledTherapy,
}

export const TYPE_OF_CARE_OPTIONS = [
  {
    label: 'Resident monitoring',
    value: typeOfCare.residentMonitoring,
  },
  {
    label: 'Restorative nursing',
    value: typeOfCare.restorativeNursing,
  },
  {
    label: 'Skilled therapy',
    value: typeOfCare.skilledTherapy,
  },
];
/**
 * @description we set the value false for yes because we use it
 * to set the property nonAmbulatory in the backend, so if we ask:
 * is the patient ambulatory and the answer is yes, the value of
 * nonAmbulatory should be false
 */
export const AMBULATORY_OPTIONS = [
  SELECT_NONE_OPTION,
  {
    label: 'Yes',
    value: false,
  },
  {
    label: 'No',
    value: true,
  },
];

export const emptyStatePhaseLabel = 'Onboarding';

export const TREATMENT_PHASE_OPTIONS = [
  {
    label: 'Ongoing',
    value: 1,
  },
  {
    label: emptyStatePhaseLabel,
    value: 2,
  },
  {
    label: 'Hybrid',
    value: 3,
  },
];

export const K_LEVEL_OPTIONS = [
  {
    label: 'None',
    value: -1,
  },
  {
    label: 'K0',
    value: 0,
  },
  {
    label: 'K1',
    value: 1,
  },
  {
    label: 'K2',
    value: 2,
  },
  {
    label: 'K3',
    value: 3,
  },
  {
    label: 'K4',
    value: 4,
  },
];
